import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { Link, useMatchRoute } from "@tanstack/react-router";

import { usePendingActions } from "@/domains/profile/queries/use-pending-actions";
import { SURVEY_INTERNAL_UTM_CONTENTS } from "@/domains/surveys/models/constants";
import { focusRing } from "@/ui";

export const PendingActionBanner = () => {
  const { data: pendingActions = [] } = usePendingActions();
  const matchRoute = useMatchRoute();

  const isSurvey = !!matchRoute({ to: "/survey" });

  if (isSurvey || !pendingActions.length) {
    return null;
  }

  return (
    <Link
      className={`flex min-h-12 animate-slide-in-from-top cursor-pointer items-center justify-center gap-2 bg-accent px-4 py-3 text-center text-accent-content transition-colors hover:bg-accent-hover md:text-base ${focusRing}`}
      search={{ utm_content: SURVEY_INTERNAL_UTM_CONTENTS.NOTIFICATION }}
      to="/survey"
    >
      <span>
        <span className="font-bold">Action Item:</span> Complete Check-In
      </span>

      <ArrowRightIcon aria-hidden="true" className="h-5 shrink-0 animate-arrow" />
    </Link>
  );
};
